<header-title [model]="headerTitle"></header-title>

<section role="main" class="">
    <section class="card mt-4">
        <header class="card-header">
            <h5 class="text-muted"><i class="fas fa-tasks"></i> Request External Audit</h5>
        </header>
        <div class="card-body">

            <div class="container" *ngIf="!showForm">
                <div class="row mt-5">
                    <div class="col">
                        <div class="row d-flex justify-content-center">
                            <div class="col-lg-8">
                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <h5 class="text-mutedtext-white">Select Company</h5>
                                        <div class="form-group">
                                            <label class="control-label text-primary">Which company is the Audit for</label>
                                            <select class="form-control" [(ngModel)]="cId">
                                                <option value="none" selected>Select Company</option>
                                                <option *ngFor="let c of companyUserList" [value]="c.companyId">{{c.tradingName}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <div class="form-group text-right">
                                            <button class="btn btn-success" type="button" (click)="setCompany(cId);" [disabled]="cId=='none'">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <form [formGroup]="requestExteralAuditForm" *ngIf="!submitSuccesful && showForm">
                <error-message [errors]="errors"></error-message>
                <div class="container">

                    <div class="row mt-5">
                        <div class="col">
                            <div class="row d-flex justify-content-center">
                                <div class="col-lg-8">

                                    <div class="alert alert-danger" *ngIf="showNoAuditAlert">
                                        <span class="fas fa-exclamation-circle"></span> No Audit Templates have been assigned to this firm
                                    </div>

                                    <div class="row mb-2">
                                        <div class="col-md-12">
                                            <p>Please check the details and add a message. Upon receiving your request a Comply365 consultant will be in contact to discuss any specific requirements and delivery dates.</p>
                                        </div>
                                    </div>


                                    <div class="row mb-2">
                                        <div class="col-md-3">
                                            <label class="col-form-label">Audit Template</label>
                                        </div>
                                        <div class="col-md-9">
                                            <!--<p>{{requestExteralAuditForm.controls.auditTypeName.value}}</p>-->
                                            <input type="hidden" formControlName="auditTypeId" />
                                            <input type="hidden" formControlName="auditTypeName" />
                                            <select id="auditTemplateId" class="form-select" (change)="selectAuditType($event.target.value)">
                                                <option *ngFor="let a of auditTemplates" [value]="a.id">{{ a.description}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-3">
                                            <label class="col-form-label">Requested by</label>
                                        </div>
                                        <div class="col-md-9">
                                            <p>{{requestExteralAuditForm.controls.siteUserName.value}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-3">
                                            <label class="col-form-label">Company</label>
                                        </div>
                                        <div class="col-md-9">
                                            <p>{{requestExteralAuditForm.controls.companyName.value}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-3">
                                            <label class="col-form-label">Email</label>
                                        </div>
                                        <div class="col-md-9">
                                            <p>{{requestExteralAuditForm.controls.siteUserEmail.value}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-3">
                                            <label class="col-form-label">Phone</label>
                                        </div>
                                        <div class="col-md-9">
                                            <p>{{requestExteralAuditForm.controls.siteUserPhone.value}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-12">
                                            <label class="col-form-label">Optional Message</label>
                                            <textarea name="message" class="form-control" formControlName="message"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row my-5">
                                <div class="col text-end">
                                    <button class="btn btn-success" type="button" [disabled]="!requestExteralAuditForm.valid" (click)="submitRequest();">Request External Audit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="container" *ngIf="submitSuccesful">

                <div class="row mt-5">
                    <div class="col">
                        <div class="row d-flex justify-content-center">
                            <div class="col-lg-8">
                                <div class="row mb-2">
                                    <div class="col-md-12">
                                        <h5 class="text-primary">External Audit Request has been received</h5>
                                        <p>You will receive a copy of the request via email for your records, and a Comply365 consultant will be in contact to discuss any specific requirements and delivery dates.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
